import { IScopeClause } from "@/api";
import { useOrganizationProxy } from "@/hooks/useOrganizationProxy";
import { Link } from "@mui/material";

interface IProps {
    scopeClause: IScopeClause;
}

export const ScopeClauseLink = ({ scopeClause }: IProps) => {
    const { proxyIntoOrganization, isPending } = useOrganizationProxy({
        navigationPath: `/organizations/scopes/${scopeClause.scope_id}?clause=${scopeClause.clause.id}`,
    });

    return (
        <Link
            component="button"
            sx={{
                display: "inline-flex",
                alignItems: "center",
            }}
            onClick={() =>
                proxyIntoOrganization(scopeClause.scope.organization_id)
            }
            disabled={isPending}
        >
            {scopeClause.scope.document_title}
        </Link>
    );
};
